import Api from "../../service";


async function getOptions() {

    return await Api.get('/api/v1/options');
}

export default getOptions;